module.exports = __webpack_public_path__ + "img/VA_logo.960a152f.png";